/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ApiSignInFailureKind {
  HandshakeFailed = 'handshakeFailed',
  InvalidEmail = 'invalidEmail',
  UnableToRetrieveMicrosoftAccountInfo = 'unableToRetrieveMicrosoftAccountInfo',
  UserInfoNotSyncedFromFlow = 'userInfoNotSyncedFromFlow',
  UnableToCreateUser = 'unableToCreateUser',
  UnableToCompleteSignIn = 'unableToCompleteSignIn',
  DisallowedInternalDomainSignUp = 'disallowedInternalDomainSignUp'
}
